module.exports = __webpack_public_path__ + "img/biolink-social.c4c7634.jpg";